// Onde as credenciais da sessão ficam no navegador.
//
// Resposta curta: o token de acesso fica em MEMÓRIA, e o refresh NÃO FICA COM
// O JAVASCRIPT — ele vive num cookie HttpOnly que só o servidor lê e escreve.
//
// ---------------------------------------------------------------------------
// POR QUE ASSIM
//
// Um webmail renderiza HTML escrito por estranhos. A higienização é séria
// (bluemonday, 16 formas de ataque travadas em teste), mas XSS em webmail é a
// classe de falha mais cara que existe, e nenhuma higienização é eterna.
//
// O que se está impedindo aqui é o roubo do que ficou GUARDADO. Com o refresh
// em sessionStorage ou localStorage, um XSS EXFILTRA a credencial: o atacante
// leva o token embora e usa de outra máquina, por dias. Com o cookie HttpOnly
// não há o que levar — ele continua podendo agir enquanto a página está
// aberta, o que é inevitável, mas a janela fecha junto com a aba.
//
// O token de acesso fica só em memória pelo mesmo motivo, e some a cada F5.
// Não é perda: o cookie o reconstrói, e por ser cookie ele é compartilhado
// entre abas — abrir o webmail numa segunda aba já entra logado, coisa que
// sessionStorage não fazia.
//
// O servidor está em api/interno/web/cookie.go. É código de autenticação:
// mudanças ali são revisão humana pela regra 5.
// ---------------------------------------------------------------------------

let tokenEmMemoria: string | null = null;

// QUEM ESTA ABA ACHA QUE É. Guardado ao lado do token, e não só no estado do
// React, porque quem precisa consultar isto é a RENOVAÇÃO — que roda fora da
// árvore de componentes, no cliente HTTP.
//
// Existe por um defeito real, reproduzido em 26/10/2026: o cookie de
// renovação tem UM nome por origem, então entrar com uma segunda conta na
// mesma origem SOBRESCREVE o da primeira. A primeira aba continuava
// funcionando até o token dela expirar; aí ela renovava, recebia o token da
// OUTRA pessoa e passava a mostrar a caixa dela — com o nome da primeira
// ainda no topo. Medido com duas caixas de laboratório dividindo o mesmo
// pote de cookies:
//
//     aba 1 entra como maria  -> cookie = refresh da maria
//     aba 2 entra como joao   -> cookie SOBRESCRITO
//     aba 1 renova            -> servidor devolve caixa: joao@teste1.local
//
// O servidor estava certo: ele devolve a identidade do cookie que recebeu, e
// sempre devolveu `caixa` na resposta. Quem errava era este lado, que lia só
// `{ token }` e adotava em silêncio.
let contaEmMemoria: string | null = null;

// A aba está DENTRO da caixa de um cliente (personificação)?
//
// Importa para a renovação dizer a verdade. A sessão personificada dura 30
// minutos e NÃO grava cookie — o cookie que está no navegador continua sendo
// o do administrador. Quando o token da personificação expira, a renovação
// devolve a identidade do ADMINISTRADOR, que é legítima e não é a desta aba.
//
// Sem distinguir, o aviso diria "outra conta entrou neste navegador", que é
// falso: ninguém entrou, a personificação é que acabou.
let personificandoEmMemoria = false;

export const deposito = {
  token(): string | null {
    return tokenEmMemoria;
  },

  guardarToken(token: string | null): void {
    tokenEmMemoria = token;
  },

  /** O endereço da conta desta aba, ou null quando não há sessão. */
  conta(): string | null {
    return contaEmMemoria;
  },

  guardarConta(caixa: string | null, personificando = false): void {
    contaEmMemoria = caixa;
    personificandoEmMemoria = personificando;
  },

  personificando(): boolean {
    return personificandoEmMemoria;
  },

  /**
   * Esquece o que este código controla.
   *
   * O cookie NÃO é apagado aqui — o JavaScript não consegue, e é esse o
   * ponto. Quem o apaga é o servidor, no /auth/logout e quando uma renovação
   * falha. Se esta função fingisse apagá-lo, a aplicação acharia que saiu
   * enquanto a sessão continuava de pé.
   */
  limpar(): void {
    tokenEmMemoria = null;
    contaEmMemoria = null;
    personificandoEmMemoria = false;
  },
};
